var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishResult12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1621.43 350",
    style: {
      enableBackground: "new 0 0 1621.43 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.3;fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{opacity:0.1;fill:#FFFFFF;}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:url(#SVGID_9_);}\n\t.st10{opacity:0.25;}\n\t.st11{fill:url(#SVGID_10_);}\n\t.st12{fill:url(#SVGID_11_);}\n\t.st13{fill:url(#SVGID_12_);}\n\t.st14{fill:url(#SVGID_13_);}\n\t.st15{fill:url(#SVGID_14_);}\n\t.st16{fill:url(#SVGID_15_);}\n\t.st17{fill:url(#SVGID_16_);}\n\t.st18{fill:url(#SVGID_17_);}\n\t.st19{fill:url(#SVGID_18_);}\n\t.st20{fill:url(#SVGID_19_);}\n\t.st21{fill:url(#SVGID_20_);}\n\t.st22{fill:url(#SVGID_21_);}\n\t.st23{fill:url(#SVGID_22_);}\n\t.st24{fill:url(#SVGID_23_);}\n\t.st25{fill:url(#SVGID_24_);}\n\t.st26{fill:url(#SVGID_25_);}\n\t.st27{fill:url(#SVGID_26_);}\n\t.st28{fill:url(#SVGID_27_);}\n\t.st29{fill:url(#SVGID_28_);}\n\t.st30{fill:url(#SVGID_29_);}\n\t.st31{fill:url(#SVGID_30_);}\n\t.st32{fill:url(#SVGID_31_);}\n\t.st33{fill:url(#SVGID_32_);}\n\t.st34{fill:url(#SVGID_33_);}\n\t.st35{fill:url(#SVGID_34_);}\n\t.st36{fill:url(#SVGID_35_);}\n\t.st37{fill:url(#SVGID_36_);}\n\t.st38{fill:url(#SVGID_37_);}\n\t.st39{fill:url(#SVGID_38_);}\n\t.st40{fill:url(#SVGID_39_);}\n\t.st41{fill:url(#SVGID_40_);}\n\t.st42{fill:url(#SVGID_41_);}\n\t.st43{opacity:0.6;}\n\t.st44{fill:url(#SVGID_42_);}\n\t.st45{fill:url(#SVGID_43_);}\n\t.st46{fill:url(#SVGID_44_);}\n\t.st47{fill:url(#SVGID_45_);}\n\t.st48{fill:url(#SVGID_46_);}\n\t.st49{fill:url(#SVGID_47_);}\n\t.st50{fill:url(#SVGID_48_);}\n\t.st51{fill:url(#SVGID_49_);}\n\t.st52{fill:url(#SVGID_50_);}\n\t.st53{fill:url(#SVGID_51_);}\n\t.st54{fill:url(#SVGID_52_);}\n\t.st55{fill:url(#SVGID_53_);}\n\t.st56{fill:url(#SVGID_54_);}\n\t.st57{fill:url(#SVGID_55_);}\n\t.st58{fill:url(#SVGID_56_);}\n\t.st59{fill:url(#SVGID_57_);}\n\t.st60{fill:url(#SVGID_58_);}\n\t.st61{fill:url(#SVGID_59_);}\n\t.st62{fill:url(#SVGID_60_);}\n\t.st63{fill:url(#SVGID_61_);}\n\t.st64{fill:url(#SVGID_62_);}\n\t.st65{fill:url(#SVGID_63_);}\n\t.st66{fill:url(#SVGID_64_);}\n\t.st67{fill:url(#SVGID_65_);}\n\t.st68{fill:url(#SVGID_66_);}\n\t.st69{fill:url(#SVGID_67_);}\n\t.st70{fill:url(#SVGID_68_);}\n\t.st71{fill:url(#SVGID_69_);}\n\t.st72{fill:url(#SVGID_70_);}\n\t.st73{fill:url(#SVGID_71_);}\n\t.st74{fill:url(#SVGID_72_);}\n\t.st75{fill:url(#SVGID_73_);}\n\t.st76{fill:url(#SVGID_74_);}\n\t.st77{fill:url(#SVGID_75_);}\n\t.st78{fill:url(#SVGID_76_);}\n\t.st79{fill:url(#SVGID_77_);}\n\t.st80{fill:url(#SVGID_78_);}\n\t.st81{fill:url(#SVGID_79_);}\n\t.st82{fill:url(#SVGID_80_);}\n\t.st83{fill:url(#SVGID_81_);}\n\t.st84{fill:url(#SVGID_82_);}\n\t.st85{fill:url(#SVGID_83_);}\n\t.st86{fill:url(#SVGID_84_);}\n\t.st87{fill:url(#SVGID_85_);}\n\t.st88{fill:url(#SVGID_86_);}\n\t.st89{fill:url(#SVGID_87_);}\n\t.st90{fill:url(#SVGID_88_);}\n\t.st91{opacity:0.5;fill:url(#SVGID_89_);}\n\t.st92{opacity:0.3;fill:url(#SVGID_90_);}\n\t.st93{fill:url(#SVGID_91_);}\n\t.st94{opacity:0.2;fill:url(#SVGID_92_);}\n\t.st95{fill:url(#SVGID_93_);}\n\t.st96{opacity:0.5;fill:url(#SVGID_94_);}\n\t.st97{fill:url(#SVGID_95_);}\n\t.st98{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1212.7925,
    y1: 296.908,
    x2: 1281.7198,
    y2: 296.908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1281.72,265.18c-20.72,50.44-68.25,63.46-68.25,63.46s-1.36-7.33-0.23-19.88c0.4-4.5,1.13-9.67,2.37-15.44 c1.7-8.05,2.68-16.02,3.2-22.88c1.21-0.06,2.42-0.14,3.64-0.2c3.23-0.17,6.44-0.35,9.58-0.55c2.89-0.17,5.74-0.35,8.54-0.55 c1.96-0.12,3.92-0.26,5.86-0.4c0.23-0.03,0.49-0.03,0.72-0.06c1.18-0.09,2.34-0.17,3.49-0.26h0.03c0.52-0.03,1.04-0.09,1.59-0.14 c1.36-0.09,2.71-0.2,4.01-0.32c0.14,0,0.26-0.03,0.38-0.03c1.85-0.17,3.67-0.32,5.45-0.49c0.26-0.03,0.52-0.06,0.78-0.09 c0.17,0,0.35-0.03,0.52-0.03c1.82-0.2,3.61-0.38,5.34-0.55c2.25-0.23,4.42-0.49,6.55-0.75c1.47-0.17,2.91-0.35,4.33-0.55 C1280.33,265.38,1281.03,265.29,1281.72,265.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1236.9169,
    y1: 287.9384,
    x2: 1286.3829,
    y2: 329.4899
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1281.72,265.18c-20.72,50.44-68.25,63.46-68.25,63.46s-1.36-7.33-0.23-19.88 c20.21-9.01,24.96-26.66,27.33-39.62c1.96-0.12,3.92-0.26,5.86-0.4c0.23-0.03,0.49-0.03,0.72-0.06c1.18-0.09,2.34-0.17,3.49-0.26 h0.03c0.52-0.03,1.04-0.09,1.59-0.14c1.36-0.09,2.71-0.2,4.01-0.32c0.14,0,0.26-0.03,0.38-0.03c1.85-0.17,3.67-0.32,5.45-0.49 c0.26-0.03,0.52-0.06,0.78-0.09c0.17,0,0.35-0.03,0.52-0.03c1.82-0.2,3.61-0.38,5.34-0.55c2.25-0.23,4.42-0.49,6.55-0.75 c1.47-0.17,2.91-0.35,4.33-0.55C1280.33,265.38,1281.03,265.29,1281.72,265.18z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 849.4321,
    y1: 329.5128,
    x2: 848.5988,
    y2: 175.338
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1507.42,194.91c-0.03,0.03-0.06,0.03-0.06,0.03s82.22-3.75,112.06-3.43c0.69,1.62-0.09,3.46-4.04,5.45 c-7.42,3.69-84.9,23.87-151.85,38.5c-0.03,0-0.06,0.03-0.12,0.03c-0.84,0.2-1.64,0.35-2.48,0.52c-3.69,0.81-7.36,1.62-10.97,2.37 c-4.21,0.92-8.4,1.76-12.47,2.6c-2.6,0.55-5.14,1.04-7.65,1.53c-2.83,0.58-5.63,1.13-8.34,1.64c-1.59,0.29-3.15,0.58-4.68,0.87 c-3.58,0.66-7.04,1.3-10.36,1.88c-0.06,0-0.14,0.03-0.2,0.03c-8.69,1.24-17.34,2.48-25.89,3.69c-1.24,0.17-2.45,0.35-3.69,0.52 c-0.14,0.03-0.29,0.06-0.43,0.09c-24.39,3.49-47.59,6.81-67.12,9.78c-1.96,0.29-3.87,0.58-5.74,0.87c-1.1,0.17-2.19,0.35-3.26,0.49 c-2.57,0.43-5.02,0.81-7.42,1.18c-0.43,0.09-0.89,0.14-1.33,0.23h-0.12c-0.49,0.09-0.95,0.17-1.41,0.23 c-1.65,0.26-3.29,0.52-4.99,0.75c-0.2,0.03-0.43,0.09-0.66,0.09v0.03c-0.17,0-0.32,0.03-0.49,0.06c-1.36,0.2-2.71,0.38-4.1,0.55 c-1.41,0.2-2.86,0.38-4.33,0.55c-2.14,0.26-4.3,0.52-6.55,0.75c-1.73,0.17-3.52,0.35-5.34,0.55c-0.17,0-0.35,0.03-0.52,0.03 c-0.26,0.03-0.52,0.06-0.78,0.09c-1.79,0.17-3.61,0.32-5.45,0.49c-0.12,0-0.23,0.03-0.38,0.03c-1.3,0.12-2.65,0.23-4.01,0.32 c-0.55,0.06-1.07,0.12-1.59,0.14h-0.03c-1.15,0.09-2.31,0.17-3.49,0.26c-0.23,0.03-0.49,0.03-0.72,0.06 c-4.67,0.35-9.49,0.66-14.4,0.95c-3.15,0.2-6.35,0.38-9.58,0.55c-7.71,0.43-15.58,0.78-23.61,1.13c-2.19,0.09-4.42,0.17-6.64,0.26 c-2.83,0.09-5.69,0.2-8.54,0.32c-1.13,0.03-2.22,0.09-3.35,0.12c-6.49,0.23-13.02,0.46-19.54,0.66c-8.05,0.29-16.1,0.55-24.13,0.81 c-9.98,0.35-19.88,0.72-29.58,1.13h-0.26c-2.22,0.09-4.42,0.2-6.64,0.29l-1.67,0.09c-3.46,0.14-6.93,0.32-10.3,0.49l-0.26,0.03 c-2.19,0.09-4.39,0.2-6.55,0.35c-0.89,0.03-1.82,0.09-2.71,0.14l-0.75,0.06c-7.85,0.46-15.47,0.98-22.77,1.59 c-0.26,0.03-0.52,0.03-0.75,0.06c-2.45,0.2-4.85,0.4-7.24,0.63c-0.66,0.09-1.36,0.14-2.02,0.2c-2.86,0.26-5.66,0.55-8.4,0.87 c-3.38,0.38-6.93,0.72-10.65,1.01h-0.2c-7.04,0.58-14.66,0.95-22.74,1.21l-0.38,0.03c-4.27,0.14-8.69,0.23-13.19,0.29 c-1.85,0.03-3.75,0.06-5.63,0.09h-3.12c-7.56,0.06-15.35,0.03-23.29-0.12c-1.5,0-3-0.03-4.53-0.06c-1.39-0.03-2.77-0.06-4.16-0.09 c-2.54-0.06-5.08-0.12-7.65-0.14l-8.51-0.26c-8.48-0.26-17.06-0.58-25.57-0.95h-0.23c-6.95-0.29-13.88-0.63-20.75-0.98l-10.42-0.55 c-6.41-0.35-12.73-0.72-18.87-1.1l-2.16-0.14c-2.25-0.14-4.5-0.29-6.72-0.4c-19.8-1.3-37.83-2.63-52.49-3.78 c-0.72-0.03-1.44-0.09-2.14-0.14c-2.16-0.17-4.21-0.32-6.2-0.49c-2.57-0.2-4.99-0.4-7.27-0.61c-4.53-0.35-8.46-0.69-11.69-0.95 c-2.68-0.23-6.18-0.58-10.36-1.04c-0.29,0-0.55-0.03-0.84-0.06c-1.1-0.14-2.25-0.26-3.43-0.4c-2.08-0.23-4.3-0.49-6.67-0.75 c-8.48-1.01-18.64-2.28-30.01-3.75l-4.44-0.58l-5.22-0.66l-3.67-0.49c-2.37-0.32-4.76-0.63-7.19-0.95h-0.09 c-5.8-0.78-11.83-1.59-18.01-2.42c-2.77-0.38-5.6-0.75-8.43-1.15c-7.88-1.07-15.96-2.19-24.15-3.32c-3.35-0.46-6.7-0.95-10.07-1.41 v-0.03c-1.99-0.26-3.98-0.55-5.97-0.81c-3.29-0.46-6.58-0.95-9.87-1.41c-1.21-0.17-2.42-0.35-3.64-0.52 c-14.46-2.08-29-4.18-43.23-6.29c-1.76-0.29-3.52-0.55-5.28-0.81c-3.12-0.46-6.23-0.92-9.29-1.39c-1.85-0.29-3.69-0.58-5.54-0.84 l-3.75-0.58l-6.12-0.95l-4.13-0.63l-9.67-1.5c-0.98-0.14-1.93-0.29-2.89-0.43c-0.35-0.06-0.69-0.12-1.04-0.17l-6.23-0.98 c-2.08-0.35-4.16-0.66-6.2-0.98c-0.52-0.09-1.07-0.17-1.59-0.26c-1.1-0.17-2.16-0.38-3.23-0.55l-0.17-0.03 c-1.44-0.23-2.86-0.46-4.24-0.66c-2.57-0.43-5.11-0.84-7.56-1.27c-0.72-0.12-1.41-0.23-2.11-0.35c-2.48-0.4-4.88-0.81-7.21-1.21 c-7.3-1.24-13.97-2.42-19.83-3.52c-2.74-0.52-5.31-1.01-7.71-1.47l-5.57-1.13c-1.33-0.29-2.54-0.55-3.69-0.81 c-0.92-0.2-1.76-0.4-2.57-0.61c-2.74-0.66-5.92-1.36-9.41-2.05c-2.45-0.52-5.05-1.01-7.82-1.53c-3.2-0.58-6.55-1.18-10.13-1.79 l-0.61-0.12c-0.14-0.03-0.32-0.06-0.46-0.09c-4.1-0.69-8.4-1.39-12.87-2.11c-0.92-0.14-1.82-0.29-2.77-0.43 c-3.41-0.52-6.93-1.07-10.5-1.62c-10.48-1.59-21.64-3.17-33.04-4.76c-2.48-0.32-4.99-0.66-7.47-1.01c-0.98-0.14-1.96-0.26-2.97-0.4 l-1.36-0.17c-11.6-1.59-23.26-3.09-34.54-4.53l-5.37-0.69l-0.75-0.09c-1.18-0.14-2.37-0.32-3.55-0.46 c-2.05-0.26-4.07-0.52-6.06-0.78c-5.6-0.69-11.02-1.36-16.22-1.99c-3.41-0.43-6.72-0.84-9.93-1.24c-3.55-0.4-6.95-0.84-10.19-1.21 c-4.1-0.49-7.94-0.95-11.46-1.39l-34.77-3.55c-0.4-0.06-0.81-0.12-1.24-0.12c0,0-0.03,0-0.06,0v-0.03c-0.72,0-1.5-0.03-2.28-0.09 c-0.98,0-1.99-0.06-3.03-0.09c-1.53-0.06-3.12-0.12-4.76-0.14c-0.4-0.03-0.78-0.03-1.18-0.06c-6.2-0.17-13.13-0.32-20.43-0.49 l-1.56-0.03c-6.2-0.14-12.64-0.29-19.08-0.46v0.26l-14.43-0.61c-8.14-0.35-16.3,0.35-24.3,1.85c-7.21,1.36-13.77,1.99-19.54,1.96 c-19.1-0.06-29.67-7.27-26.98-18.87c2.68-11.6,29.06-11.08,45.05-9.67c8.02,0.69,16.1,0.49,24.07-0.69 c0.89-0.12,1.82-0.26,2.71-0.4l10.33-1.79l3.09-0.52c3.32-0.55,6.72-1.13,10.22-1.67l7.76-1.27c4.24-0.69,8.57-1.39,12.99-2.11 c0.03,0,0.09,0,0.12-0.03c2.08-0.29,4.13-0.63,6.23-0.98h0.12c6.32-1.01,12.78-2.02,19.31-3.03c2.94-0.46,5.92-0.92,8.89-1.36 c24.39-3.78,49.52-7.53,72.35-10.82l8.02-1.13c1.56-0.23,3.12-0.46,4.65-0.66c1.53-0.23,3.06-0.43,4.56-0.63 c5.08-0.72,10.01-1.41,14.72-2.05c1.24-0.17,2.48-0.35,3.69-0.49c6.44-0.89,12.44-1.67,17.86-2.37c0.84-0.12,1.7-0.23,2.51-0.32 c5.57-0.69,10.48-1.3,14.66-1.76c1.56-0.17,3.29-0.38,5.19-0.61c0.75-0.09,1.56-0.17,2.37-0.29c2.45-0.29,5.14-0.61,8.05-0.98 c1.76-0.23,3.64-0.46,5.54-0.72c0.26-0.03,0.52-0.06,0.78-0.09c0.84-0.12,1.64-0.2,2.48-0.32c2.86-0.38,5.83-0.75,9-1.15 c2.19-0.29,4.44-0.58,6.78-0.89c1.9-0.23,3.84-0.49,5.83-0.75c2.42-0.32,4.91-0.63,7.47-0.98c19.68-2.54,43.34-5.6,70.15-8.95 c2.8-0.35,5.66-0.69,8.51-1.04c1.7-0.2,3.41-0.43,5.11-0.63c5.83-0.72,11.8-1.44,17.89-2.19c29.93-3.58,62.85-7.39,97.86-11.14 c2.71-0.29,5.4-0.58,8.14-0.87c2.71-0.29,5.43-0.58,8.17-0.87c5.05-0.52,10.13-1.04,15.27-1.56c6-0.63,12.06-1.24,18.18-1.85 c6.9-0.66,13.85-1.36,20.89-2.02c1.59-0.14,3.2-0.32,4.82-0.46c5.77-0.55,11.57-1.1,17.4-1.62c1.5-0.14,3-0.29,4.5-0.4 c4.36-0.4,8.72-0.78,13.1-1.18c14.75-1.3,29.67-2.57,44.7-3.75c0.55-0.03,1.1-0.09,1.64-0.14c5.48-0.43,10.97-0.87,16.48-1.27 c10.42-0.78,20.89-1.56,31.43-2.25c1.7-0.12,3.41-0.23,5.11-0.38c2.42-0.14,4.91-0.32,7.36-0.46c4.96-0.35,9.96-0.66,14.92-0.95 c6.93-0.46,13.85-0.87,20.78-1.24c2.28-0.14,4.56-0.26,6.81-0.38c33.99-1.9,68.05-3.32,101.61-4.1c0.03-0.03,0.03-0.03,0.06,0 c9.58-0.26,19.13-0.43,28.63-0.55c3.55-0.06,7.1-0.09,10.65-0.12c1.15-0.03,2.34-0.03,3.49-0.03c1.7-0.03,3.38-0.06,5.08-0.03 c8.6-0.09,17.17-0.09,25.65,0c2.86,0,5.71,0,8.57,0.06c2.25,0.03,4.47,0.03,6.72,0.06c5.17,0.06,10.27,0.14,15.35,0.26 c1.41,0.03,2.86,0.06,4.27,0.09c13.16,0.29,26.12,0.72,38.84,1.33c4.44,0.2,8.86,0.4,13.22,0.66c7.59,0.4,15.09,0.87,22.48,1.39 c1.82,0.12,3.64,0.26,5.43,0.4c4.39,0.32,8.74,0.66,13.04,1.04c1.41,0.12,2.86,0.26,4.27,0.38c22.05,1.96,43.09,4.5,62.85,7.68 c0.87,0.12,1.73,0.26,2.57,0.4c0.89,0.14,1.76,0.29,2.63,0.43c1.24,0.2,2.45,0.4,3.69,0.63c1.21,0.2,2.42,0.43,3.64,0.63 c5.48,0.98,11.14,1.99,17,3.03c7.62,1.39,15.55,2.86,23.78,4.36c0.2,0.03,0.38,0.06,0.55,0.09c3.29,0.63,6.64,1.24,10.01,1.88 c0.92,0.14,1.88,0.35,2.83,0.52c2.63,0.49,5.31,1.01,8.02,1.5c1.82,0.35,3.66,0.69,5.51,1.04c3.69,0.69,7.42,1.41,11.2,2.14 c1.88,0.38,3.78,0.75,5.69,1.1c1.9,0.38,3.84,0.75,5.77,1.13c3.84,0.75,7.73,1.5,11.66,2.28c7.33,1.44,14.75,2.91,22.28,4.42 c2.51,0.52,5.05,1.01,7.59,1.53c0.55,0.12,1.07,0.2,1.62,0.32c1.85,0.38,3.72,0.75,5.57,1.13c1.82,0.38,3.66,0.75,5.51,1.13 c0.84,0.17,1.67,0.35,2.51,0.52c4.47,0.92,8.97,1.85,13.48,2.8c4.85,1.04,9.73,2.05,14.63,3.09c4.88,1.07,9.78,2.11,14.72,3.17 c0.23,0.03,0.46,0.09,0.69,0.14c4.36,0.95,8.74,1.9,13.13,2.89c7.47,1.64,14.98,3.35,22.48,5.05c5.4,1.24,10.82,2.51,16.22,3.78 c1.07,0.26,2.14,0.49,3.2,0.75c4.65,1.1,9.29,2.19,13.94,3.32c0.87,0.17,1.7,0.38,2.57,0.63c0.06,0,0.12,0.03,0.2,0.03 c0.14,0.03,0.29,0.06,0.43,0.12c0.03,0,0.09,0.03,0.12,0.03c0.09,0.03,0.12,0.03,0.12,0.03c0.17,0.03,0.35,0.09,0.52,0.12 c1.59,0.38,3.15,0.72,4.73,1.13c1.76,0.43,3.49,0.87,5.22,1.3c3.87,0.95,7.76,1.9,11.63,2.89c1.7,0.43,3.43,0.84,5.14,1.3 c1.1,0.26,2.16,0.52,3.26,0.81c1.07,0.26,2.14,0.55,3.2,0.81c1.62,0.4,3.2,0.81,4.79,1.24c0.58,0.14,1.15,0.29,1.73,0.43 c3.61,0.92,7.16,1.85,10.74,2.8h0.03c0.32,0.09,0.63,0.17,0.95,0.26c3.58,0.92,7.1,1.88,10.65,2.83 c10.07,2.71,20.09,5.48,29.93,8.31c0,0,3.12,2.83-8.95,6.06c-0.03,0-0.03,0-0.03,0c-0.55,0.17-1.15,0.32-1.76,0.46 c-0.87,0.2-2.02,0.46-3.41,0.78c-0.66,0.14-1.36,0.29-2.14,0.46c-1.27,0.29-2.68,0.58-4.18,0.89c-0.98,0.2-1.99,0.4-3.06,0.63 c-1.18,0.26-2.42,0.49-3.69,0.75c-1.62,0.35-3.32,0.69-5.08,1.07c-0.66,0.12-1.3,0.23-1.93,0.38c-1.3,0.26-2.6,0.52-3.95,0.81 c-0.69,0.12-1.36,0.26-2.05,0.4c-1.36,0.26-2.77,0.55-4.18,0.84c-1.41,0.29-2.86,0.58-4.3,0.87l-2.16,0.43 c-2.51,0.49-5.05,0.98-7.62,1.5c-1.13,0.23-2.28,0.46-3.43,0.69c-7.42,1.44-14.83,2.91-21.64,4.24c-0.98,0.2-1.96,0.38-2.94,0.58 c-4.3,0.84-8.31,1.62-11.86,2.31c-0.55,0.09-1.07,0.2-1.59,0.32c-1.56,0.29-3.03,0.58-4.36,0.84c-0.43,0.09-0.89,0.17-1.3,0.26 c-0.84,0.14-1.64,0.29-2.37,0.43c-0.61,0.14-1.15,0.23-1.64,0.35C1509.15,194.59,1507.74,194.85,1507.42,194.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 175,
    x2: 161.4143,
    y2: 175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.41,161.92v28.74c-14.6,3.35-28.66,9.52-44.3,29.87c-0.38,0.49-0.75,0.98-1.13,1.5 c-6.52,8.74-13.3,19.97-20.52,34.51c-25.02,50.47-75.49,84.7-78.81,87.67c-3.32,2.94-22.45,12.87-14.92-2.97 c6.18-12.99,41.33-97.8,54.92-144.61c2.97-10.22,4.91-18.61,5.31-24.07c0.23-3.12-0.17-7.27-1.1-12.21 C52.88,117.05,5.67,12.87,3.04,7.59C0.1,1.67,3.04,0,3.04,0C44.65,1.27,105.43,106.28,117.2,129.86c3.87,7.71,9.9,13.79,16.3,18.47 C146.73,158.09,161.41,161.92,161.41,161.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 667.1852,
    y1: 106.5409,
    x2: 618.4632,
    y2: 2.1365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M735.31,89.75c0,0-57.48-83.45-101.93-89.53c0,0.01,31.71,42.72,3.49,69.23 c-18.92,17.78-50.98,13.35-54.32,17.06c-3.34,3.71,22.85,6.43,27.86,15.58L735.31,89.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 907.2699,
    y1: 70.7053,
    x2: 911.0076,
    y2: 190.3115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1612.12,173.87c-0.03,0-0.03,0-0.03,0s-43.78-0.69-99.96-2.16c-17.14-0.43-35.44-0.95-53.99-1.56 c-1.41-0.06-2.86-0.09-4.3-0.14c-7.04-0.2-14.08-0.46-21.12-0.69c-13.36-0.49-26.66-1.01-39.54-1.56 c-19.51-0.84-38.12-1.79-54.63-2.83c-0.29,0-0.55-0.03-0.81-0.06c-22.71-1.39-41.38-3.72-53.3-4.76 c-193.99-17-299.23-12.35-601.9-2.83c-190.23,5.97-263.48-1.96-369.15-5.97c-33.36-1.27-69.98-0.29-114.54,4.76 c6.32-1.01,12.78-2.02,19.31-3.03c2.94-0.46,5.92-0.92,8.89-1.36c24.39-3.78,49.52-7.53,72.35-10.82l8.02-1.13 c1.56-0.23,3.12-0.46,4.65-0.66c1.53-0.23,3.06-0.43,4.56-0.63c5.08-0.72,10.01-1.41,14.72-2.05c1.24-0.17,2.48-0.35,3.69-0.49 c6.44-0.89,12.44-1.67,17.86-2.37c0.84-0.12,1.7-0.23,2.51-0.32c5.57-0.69,10.48-1.3,14.66-1.76c1.56-0.17,3.29-0.38,5.19-0.61 c0.75-0.09,1.56-0.17,2.37-0.29c2.45-0.29,5.14-0.61,8.05-0.98c1.76-0.23,3.61-0.46,5.54-0.72c1.07-0.12,2.14-0.26,3.26-0.4 c2.86-0.38,5.83-0.75,9-1.15c2.19-0.29,4.44-0.58,6.78-0.89c1.9-0.23,3.84-0.49,5.83-0.75c2.42-0.32,4.91-0.63,7.47-0.98 c19.68-2.54,43.34-5.6,70.15-8.95c2.8-0.35,5.66-0.69,8.51-1.04c1.7-0.2,3.41-0.43,5.11-0.63c5.83-0.72,11.8-1.44,17.89-2.19 c29.93-3.58,62.85-7.39,97.86-11.14c2.71-0.29,5.4-0.58,8.14-0.87c2.71-0.29,5.43-0.58,8.17-0.87c5.05-0.52,10.16-1.04,15.27-1.56 c6-0.63,12.06-1.24,18.18-1.85c6.9-0.69,13.88-1.36,20.89-2.02c1.59-0.14,3.2-0.32,4.82-0.46c5.77-0.55,11.57-1.1,17.4-1.62 c1.5-0.14,3-0.29,4.5-0.4c4.36-0.4,8.72-0.78,13.1-1.18c14.75-1.3,29.67-2.57,44.7-3.75c0.55-0.03,1.1-0.09,1.64-0.14 c5.48-0.43,10.97-0.87,16.48-1.27c10.42-0.78,20.89-1.56,31.43-2.25c1.7-0.12,3.41-0.23,5.11-0.38c2.42-0.14,4.91-0.32,7.36-0.46 c4.96-0.35,9.96-0.66,14.92-0.95c6.93-0.46,13.85-0.87,20.78-1.24c2.28-0.14,4.56-0.26,6.81-0.38c33.99-1.9,68.05-3.32,101.61-4.1 c0.03-0.03,0.06,0,0.06,0c9.58-0.26,19.13-0.43,28.63-0.55c3.55-0.06,7.1-0.09,10.65-0.12c1.15-0.03,2.34-0.03,3.49-0.03 c1.7-0.03,3.38-0.06,5.08-0.03c8.6-0.09,17.17-0.09,25.65,0c2.86,0,5.71,0,8.57,0.06c2.25,0.03,4.47,0.03,6.72,0.06 c5.17,0.06,10.27,0.14,15.35,0.26c1.41,0.03,2.86,0.06,4.27,0.09c13.16,0.29,26.12,0.72,38.84,1.33c4.44,0.2,8.86,0.4,13.22,0.66 c7.59,0.4,15.09,0.87,22.48,1.39c1.82,0.12,3.64,0.26,5.43,0.4c4.39,0.32,8.74,0.66,13.04,1.04c1.41,0.12,2.86,0.26,4.27,0.38 c22.05,1.96,43.09,4.5,62.85,7.68c0.87,0.12,1.73,0.26,2.57,0.4c0.89,0.14,1.76,0.29,2.63,0.43c1.24,0.2,2.45,0.4,3.69,0.63 c1.21,0.2,2.42,0.43,3.64,0.63c5.48,0.98,11.14,1.99,17,3.03c7.62,1.39,15.55,2.83,23.78,4.36c0.2,0.03,0.38,0.06,0.55,0.09 c3.32,0.63,6.64,1.24,10.01,1.88c0.92,0.14,1.88,0.35,2.83,0.52c2.63,0.49,5.31,1.01,8.02,1.5c1.82,0.35,3.66,0.69,5.51,1.04 c3.69,0.69,7.42,1.41,11.2,2.14c1.88,0.38,3.78,0.75,5.69,1.1c1.9,0.38,3.84,0.75,5.77,1.13c3.84,0.75,7.73,1.5,11.66,2.28 c7.33,1.44,14.75,2.89,22.28,4.42c2.51,0.52,5.05,1.01,7.59,1.53c0.55,0.12,1.07,0.2,1.62,0.32c1.85,0.38,3.72,0.75,5.57,1.13 c1.82,0.38,3.66,0.75,5.51,1.13c0.84,0.17,1.67,0.35,2.51,0.52c4.47,0.92,8.97,1.85,13.48,2.8c4.85,1.04,9.73,2.05,14.63,3.09 c4.88,1.07,9.78,2.11,14.72,3.17c0.23,0.03,0.46,0.09,0.69,0.14c4.36,0.95,8.74,1.9,13.13,2.89c7.47,1.64,14.98,3.35,22.48,5.05 c5.4,1.24,10.82,2.51,16.22,3.78c1.07,0.26,2.14,0.49,3.2,0.75c4.65,1.1,9.29,2.19,13.94,3.32c0.75,0.17,1.47,0.35,2.19,0.55 c0.12,0.03,0.23,0.06,0.38,0.09c0.06,0,0.12,0.03,0.2,0.03c0.14,0.03,0.29,0.06,0.43,0.12c0.03,0,0.09,0.03,0.12,0.03 c0.09,0.03,0.12,0.03,0.12,0.03c0.17,0.03,0.35,0.09,0.52,0.12c3.32,0.78,6.64,1.59,9.96,2.42c3.87,0.95,7.76,1.9,11.63,2.89 c1.7,0.43,3.43,0.84,5.14,1.3c1.1,0.26,2.16,0.52,3.26,0.81c1.07,0.26,2.14,0.55,3.2,0.81c1.62,0.4,3.2,0.81,4.79,1.24 c0.58,0.14,1.15,0.29,1.73,0.43c3.61,0.92,7.16,1.85,10.74,2.8h0.03c0.32,0.09,0.63,0.17,0.95,0.26c3.58,0.92,7.1,1.88,10.65,2.83 c10.07,2.71,20.09,5.48,29.93,8.31C1621.06,167.81,1624.18,170.64,1612.12,173.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 923.9402,
    y1: 148.7865,
    x2: 923.9402,
    y2: 148.7865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M923.94,148.79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1216.93,142.01c12.07,2.49,19.76,14.15,17.18,26.2c-0.02,0.09-3.6,6.89-5.71,14.37 c-25.49,90.39-344.27,57.53-515.89,42.79c-17.35-1.49-38.75-16.9-45.96-34.4c-10.38-25.2,6.44-53.29,33.53-56.34 C885.1,113.8,1060.06,109.65,1216.93,142.01z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 634.454,
    y1: 239.2992,
    x2: 573.3443,
    y2: 372.6891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M572.92,245.22c0,0-6.06,11.23-20.47,15.34c-0.87,0.25-0.78,1.5,0.12,1.58c14.61,1.3,51.2,6.71,55.8,28.37 c5.76,27.16-9.6,55.42-9.6,55.42s58.54-17.67,97.58-83.32L572.92,245.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 1018.1225,
    y1: 84.0306,
    x2: 996.2184,
    y2: -76.3075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1281.23,92.5c-5.4-0.95-10.62-1.9-15.7-2.8C1137.23,66.78,950.51,72.53,779.9,86 c-0.55,0.06-1.1,0.12-1.64,0.14c-7.19,0.58-14.34,1.15-21.44,1.76h-0.12c0,0,8.08-9.47,5.48-17.23c0,0,12.06,0.81,13.79-10.24 c0,0,18.01-2.48,20.2-10.27c0,0,14.89,1.99,17.98-10.36c0,0,15.84,3.61,18.82-8.95c0,0,12.61,4.42,19.59-5.97 c0,0,13.79,2.83,18.01-5.83c0,0,16.77,4.62,20.92-7.1c0,0,17.86,4.56,20.2-3.58c0,0,17.06,5.45,23.75-2.08 c0,0,15.32,6.72,24.01,2.08c0,0,16.28,7.79,27.91,0c0,0,15.01,6.46,25.14,1.3c0,0,10.27,5.25,17.81,1.04 c0,0,11.72,5.63,21.01-1.04c0,0,10.33,5.14,19.1,0c0,0,12.32,6,20.06,0c0,0,15.04,5.57,22.13,0c0,0,12.38,5.57,21.24,0 c0,0,7.76,5.48,18.15,0c14.2,4.99,20.63-1.3,20.63-1.3c10.39,5.92,18.35,1.3,18.35,1.3c8.05,5.63,17.78,1.99,17.78,1.99 c14.28,6.93,21.24,0,21.24,0C1242.44,22.95,1280.25,90.76,1281.23,92.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 1167.9391,
    y1: -73.6428,
    x2: 1176.3792,
    y2: 98.4061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1195.52,80.4c-3.17-0.29-6.41-0.58-9.64-0.87c-6.87-29-32.7-68.02-33.88-69.87 C1153.53,11.69,1187.53,57.49,1195.52,80.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1148.7607,
    y1: -84.2259,
    x2: 1157.8811,
    y2: 101.6881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1176.27,78.73c-2.94-0.2-5.89-0.43-8.86-0.63c-7.3-26.61-32.47-66.69-33.56-68.42 C1135.26,11.52,1166.95,56.68,1176.27,78.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1127.3411,
    y1: -76.8956,
    x2: 1136.1619,
    y2: 102.9135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1153.88,77.2c-2.97-0.17-5.94-0.35-8.95-0.49c-7.24-26.92-31.2-65.28-32.32-67.04 C1114.05,11.55,1144.61,55.04,1153.88,77.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 1105.4939,
    y1: -69.8697,
    x2: 1114.0143,
    y2: 103.8165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1131.57,76.02c-2.97-0.12-5.97-0.26-9-0.38c-7.19-27.42-30.96-64.21-32.09-65.97 C1091.92,11.58,1122.51,53.68,1131.57,76.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1084.7428,
    y1: -62.9764,
    x2: 1092.9502,
    y2: 104.3288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1109.41,75.18c-3.03-0.12-6.06-0.2-9.12-0.26c-7.07-28.05-28.71-63.46-29.87-65.25 C1071.89,11.61,1100.63,52.61,1109.41,75.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1064.5238,
    y1: -68.622,
    x2: 1073.1505,
    y2: 107.2294
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M1088.6,74.63c-2.89-0.06-5.77-0.12-8.69-0.17c-7.3-26.64-27.5-63.06-28.6-64.79 C1052.73,11.52,1079.19,52.67,1088.6,74.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 1043.1396,
    y1: -65.0309,
    x2: 1051.6385,
    y2: 108.216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M1066.52,74.32c-2.86-0.06-5.71-0.06-8.57-0.06c-7.3-26.55-26.55-61.81-27.65-63.55 C1031.72,12.53,1057.12,52.41,1066.52,74.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 1023.8982,
    y1: -65.7568,
    x2: 1032.519,
    y2: 109.9754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M1045.86,74.2c-2.83,0-5.68,0-8.51,0.03c-7.3-26.52-23.75-62.82-24.85-64.56 C1013.92,11.49,1036.42,52.33,1045.86,74.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 1001.0011,
    y1: -67.5021,
    x2: 1009.8162,
    y2: 112.1896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1025.31,74.29c-2.86,0.03-5.68,0.06-8.54,0.09c-7.3-26.58-28.31-64.27-29.41-66 C988.78,10.19,1015.88,52.41,1025.31,74.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 976.8401,
    y1: -66.6276,
    x2: 985.6899,
    y2: 113.7739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M1004.83,74.55c-2.86,0.06-5.71,0.12-8.57,0.17c-7.27-26.75-35.67-64.61-36.79-66.35 C960.87,10.22,995.42,52.61,1004.83,74.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 954.5117,
    y1: -69.6427,
    x2: 963.6302,
    y2: 116.2358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M984.39,74.98c-2.86,0.06-5.71,0.12-8.6,0.2C968.55,48.2,936.58,8.06,935.45,6.3 C936.86,8.14,975.07,52.96,984.39,74.98z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 932.6585,
    y1: -64.0685,
    x2: 941.5056,
    y2: 116.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M964.02,75.53c-2.89,0.09-5.77,0.17-8.66,0.29c-7.21-27.27-42.54-65.68-43.66-67.44 C913.14,10.25,954.78,53.39,964.02,75.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 911.9417,
    y1: -59.3071,
    x2: 920.5601,
    y2: 116.3773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M942.23,76.28c-2.83,0.12-5.68,0.23-8.54,0.35c-7.27-26.9-40.76-62.84-41.89-64.6 C893.22,13.87,932.82,54.32,942.23,76.28z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 890.9683,
    y1: -54.4821,
    x2: 899.3508,
    y2: 116.3904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M921.42,77.14c-2.68,0.12-5.34,0.23-8.02,0.38c-7.16-24.56-41.09-55.67-42.83-58.47 C872.86,22.05,911.93,56.57,921.42,77.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 872.5585,
    y1: -51.3945,
    x2: 880.8036,
    y2: 116.6786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M902.64,78.01c-2.45,0.14-4.91,0.26-7.39,0.4c-7.5-23.81-41.64-51.92-42.68-53.53 C853.84,26.56,892.6,57.72,902.64,78.01z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 852.8051,
    y1: -48.4629,
    x2: 860.9252,
    y2: 117.0631
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M882.78,79.08c-2.28,0.12-4.53,0.23-6.81,0.38c-7.47-22.19-42.02-47.07-43-48.6 C834.19,32.44,872.74,59.86,882.78,79.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 832.7003,
    y1: -41.1158,
    x2: 840.4179,
    y2: 116.2035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M861.17,80.32c-1.99,0.12-3.98,0.23-5.97,0.38c-7.27-19.91-40.11-39.45-41.04-40.89 C815.28,41.24,851.39,62.69,861.17,80.32z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 813.4329,
    y1: -30.6617,
    x2: 820.5518,
    y2: 114.4551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M840.16,81.65c-1.67,0.12-3.32,0.23-4.99,0.35c-6.87-17.14-38.15-30.53-38.99-31.83 C797.19,51.46,830.98,66.15,840.16,81.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 793.1087,
    y1: -19.685,
    x2: 799.6033,
    y2: 112.7047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M819.21,83.06c-1.3,0.12-2.6,0.2-3.9,0.29c-6.12-13.97-38.61-21.76-39.33-22.91 C776.84,61.56,811.13,70.16,819.21,83.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 774.9193,
    y1: 23.1189,
    x2: 778.8008,
    y2: 102.242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M792.99,84.38c-1.27,0.08-2.57,0.17-3.84,0.3c-7.05-14.52-26.12-12.65-26.97-14 C763.2,72.03,783.88,70.66,792.99,84.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 1188.3511,
    y1: -87.9637,
    x2: 1197.446,
    y2: 97.4334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M1217.16,82.68c-3.12-0.38-6.29-0.72-9.49-1.07c-7.04-28.25-33.88-71.42-35.03-73.24 C1174.14,10.34,1208.74,59.94,1217.16,82.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 1207.0879,
    y1: -95.8862,
    x2: 1216.4744,
    y2: 95.4538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M1237.25,85.22c-3.12-0.43-6.26-0.84-9.47-1.24c-7.13-27.79-35.64-72.52-36.79-74.31 C1192.49,11.61,1228.59,62.6,1237.25,85.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 1226.9147,
    y1: -83.8522,
    x2: 1235.5649,
    y2: 92.4808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M1258.2,88.43c-3.43-0.58-6.95-1.13-10.48-1.67c-7.88-30.65-37.8-73.27-38.96-75.09 C1210.41,13.83,1248.71,63.46,1258.2,88.43z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.7299,
    y1: 141.7309,
    x2: 315.6311,
    y2: 250.9648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "297.44,141.15 308.48,130.17 325.84,137.14  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.4832,
    y1: 140.0255,
    x2: 363.3844,
    y2: 249.2594
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "340.83,135.1 357.35,122.19 377.63,130.56  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.4085,
    y1: 143.2424,
    x2: 273.3097,
    y2: 252.4763
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "254.48,147.48 266.39,135.66 284.48,143.03  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.6558,
    y1: 138.1622,
    x2: 415.557,
    y2: 247.3961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "394.47,128.44 408.02,113.76 428,124.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.6103,
    y1: 136.1638,
    x2: 471.5115,
    y2: 245.3977
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "448.6,121.44 462.28,104.85 485.4,116.77  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 520.6495,
    y1: 134.2695,
    x2: 524.5507,
    y2: 243.5034
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "502.85,114.6 515.88,98.29 536.9,110.48  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 568.3464,
    y1: 132.5661,
    x2: 572.2476,
    y2: 241.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "549.43,108.99 562.83,91.31 585.43,104.85  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.4526,
    y1: 144.9551,
    x2: 225.3538,
    y2: 254.189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "207.96,155.04 218.94,142.24 235.5,150.36  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.6297,
    y1: 146.3774,
    x2: 185.5309,
    y2: 255.6113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "171.63,160.44 180.1,149.74 192.51,157.06  "
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 900.7898,
    y1: 94.1644,
    x2: 900.7898,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M901.14,78.1l-0.7,0.04C900.67,78.12,900.91,78.11,901.14,78.1L901.14,78.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 720.4207,
    y1: 94.1644,
    x2: 720.4207,
    y2: 156.1645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M720.38,91.08L720.38,91.08c0.03,0,0.06-0.01,0.09-0.01L720.38,91.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 694.0255,
    y1: 94.1644,
    x2: 694.0255,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M694.31,93.5l-0.57,0.05C693.93,93.54,694.12,93.52,694.31,93.5L694.31,93.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 985.2134,
    y1: 94.1644,
    x2: 985.2134,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M980.84,282.09l8.72,0.02c0.01-0.03,0.01-0.07,0.02-0.11C986.71,282.04,983.8,282.07,980.84,282.09 C980.84,282.09,980.84,282.09,980.84,282.09z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 957.5204,
    y1: 278.4507,
    x2: 957.5204,
    y2: 285.4962
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M957.54,281.97L957.54,281.97c-0.02,0-0.03,0-0.05,0L957.54,281.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 1103.4972,
    y1: 94.1644,
    x2: 1103.4972,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M1106.82,274.64c-2.23,0.09-4.44,0.19-6.64,0.29L1106.82,274.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 1078.1169,
    y1: 94.1644,
    x2: 1078.1169,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M1076.76,74.42c0,0,0,0.01,0,0.01c0.91,0.01,1.82,0.03,2.73,0.04L1076.76,74.42z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 1091.714,
    y1: 94.1644,
    x2: 1091.714,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M1092.96,74.72l-2.5-0.05c0.84,0.02,1.67,0.04,2.51,0.06C1092.97,74.73,1092.96,74.72,1092.96,74.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 1083.3124,
    y1: 94.1644,
    x2: 1083.3124,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M1087.94,275.53c-3.12,0.16-6.2,0.33-9.26,0.51L1087.94,275.53z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 989.804,
    y1: 94.1644,
    x2: 989.804,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M998.3,74.43l-17,0.61c0,0,0,0.01,0,0.01c5.67-0.14,11.33-0.27,16.97-0.38 C998.29,74.53,998.3,74.43,998.3,74.43z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 844.4003,
    y1: 94.1647,
    x2: 844.4003,
    y2: 229.0974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M871.73,239.26c-4.27-9.35-4.68-19.08-7.39-37.37c-2.74-18.3,3.49-25.71,0-37.78 c-1.47-5.05-2.89-8.83-3.78-12.35c-1.24-4.88-1.53-9.29,0.26-16.07c3.12-11.66,2.34-33.59,2.34-33.59s-12.21,26.98-10.39,38.21 c0.49,3.03,1.04,7.07,1.56,11.63c1.44,12.32,2.54,28.25,0.95,37.23c-2.16,12.32,3.69,18.47,2.6,31.14 c-1.13,12.67,21.3,46.66,17.86,58.61l10.42,0.55C888.5,260.13,876.03,248.61,871.73,239.26z M844.23,233.41 c-1.76-9.61,3.03-10.48-5.97-18.35c-9.03-7.85-6.26-37.52-2.02-54.54c0.61-2.45,1.15-5.17,1.64-8.08 c2.91-17.14,3.52-40.32-0.2-50.33c-1.18-3.15-1.53-6.06-1.41-8.66c0.26-7.13,4.01-11.8,4.01-11.8h-0.12 c-1.13,0.06-2.25,0.14-3.35,0.23l-1.64,0.12l-4.79,0.32c-2.11,4.1-3.35,7.99-3.84,11.8c-0.72,5.02-0.17,9.9,1.18,14.92 c2.19,8.2,1.79,29.78,0.35,43.69c-0.12,1.07-0.23,2.11-0.35,3.09c-1.7,13.56-2.54,48.8-2.54,48.8 c-11.08-20.37-8.74-38.73-6.18-51.63c0.52-2.63,1.04-5.05,1.47-7.19c2.54-12.61-0.35-23.43-2.86-35.35 c-1.07-5.05-0.72-10.79,0.06-15.7c1.01-6.61,2.8-11.75,2.8-11.75l-7.5,0.52c-2.68,0.17-5.34,0.38-7.99,0.58 c0,0-1.18,4.96-1.82,11.69c-0.69,7.1-0.78,16.16,1.82,23.35c4.3,11.95,8.05,23.46,5.66,34.11c-0.38,1.76-0.95,3.52-1.7,5.22 c-5.37,12.09-9.49,14.75-3.95,26.55c5.54,11.77,9.29,17.66,9.29,25.16c0,7.5,17.69,18.21,18.76,28.92 c1.07,10.71,15.99,28.14,14.95,38.18l6.72,0.4l2.16,0.14C858.63,255.02,845.96,242.99,844.23,233.41z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 829.6971,
    y1: 94.1644,
    x2: 829.6971,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M838.25,215.06c-9.02-7.86-6.26-37.54-2.02-54.56c4.24-17.02,5.8-46.71,1.44-58.41 c-4.37-11.7,2.6-20.45,2.6-20.45l-9.89,0.66c-4.9,9.54-5.03,17.92-2.66,26.74c2.37,8.81,1.69,33.21,0,46.77 c-1.69,13.56-2.53,48.79-2.53,48.79c-13.34-24.53-7.22-46.17-4.7-58.8c2.52-12.63-0.36-23.45-2.88-35.35s2.88-27.46,2.88-27.46 l-15.51,1.12c0,0-5.02,21.1,0,35.02c5.02,13.92,9.3,27.27,3.95,39.34c-5.36,12.07-9.5,14.75-3.95,26.53 c5.55,11.78,9.3,17.67,9.3,25.17c0,7.5,17.67,18.21,18.74,28.92c1.07,10.71,15.98,28.15,14.95,38.17l8.9,0.56 c1.75-22.8-10.92-34.82-12.66-44.43C842.47,223.79,847.27,222.92,838.25,215.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 607.7253,
    y1: 94.1644,
    x2: 607.7253,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M621.73,229.49c-9.02-7.86-6.26-37.54-2.02-54.56c4.24-17.02,5.8-46.71,1.44-58.41 c-2.39-6.4-1.38-11.91,0.02-15.59c-3.19,0.34-6.36,0.69-9.52,1.03c-2.6,7.45-2.37,14.34-0.44,21.51c2.37,8.81,1.69,33.21,0,46.77 c-1.69,13.56-2.53,48.79-2.53,48.79c-13.34-24.53-7.22-46.17-4.7-58.8c2.52-12.63-0.36-23.45-2.88-35.35 c-1.58-7.44-0.06-16.3,1.3-21.91c-5.07,0.56-10.09,1.12-15.06,1.67c-1.11,7.3-2.2,19.67,1.13,28.91 c5.02,13.92,9.3,27.27,3.95,39.34c-5.36,12.07-9.5,14.75-3.95,26.53c5.55,11.78,9.3,17.67,9.3,25.17 c0,7.03,15.55,16.89,18.36,26.93c4.51,0.65,9.02,1.29,13.5,1.92c-0.91-1.99-1.61-3.85-1.93-5.62 C625.95,238.22,630.75,237.35,621.73,229.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 493.0188,
    y1: 94.1644,
    x2: 493.0188,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M509.18,232.38c-9.02-7.86-6.26-37.54-2.02-54.56c4.24-17.02,5.8-46.71,1.44-58.41 c-0.7-1.87-1.08-3.65-1.27-5.34c-3.42,0.42-6.8,0.84-10.14,1.25c-0.06,3.68,0.46,7.32,1.46,11.04c2.37,8.81,1.69,33.21,0,46.77 c-1.69,13.56-2.53,48.79-2.53,48.79c-13.34-24.53-7.22-46.17-4.7-58.8c2.52-12.63-0.36-23.45-2.88-35.35 c-0.77-3.62-0.8-7.56-0.47-11.32c-4.88,0.61-9.66,1.21-14.31,1.8c-0.23,6.02,0.17,12.67,2.16,18.2 c5.02,13.92,9.3,27.27,3.95,39.34c-5.36,12.07-9.5,14.75-3.95,26.53c5.55,11.78,9.3,17.67,9.3,25.17c0,1.3,0.55,2.69,1.43,4.16 c8,1.37,16.77,2.81,26.11,4.31C511.92,234.92,510.77,233.76,509.18,232.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 895.6423,
    y1: 94.1644,
    x2: 895.6423,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M876.17,132.97c-3.07,7.08,10.95,14.53,10.95,23.29c0,8.76-6.13,44.68-3.07,56.06 c3.07,11.39,26.45,43.43,22.86,68.14h7.16c7.34-22.13-15.04-61.09-17.27-65.64c-2.23-4.55,3.63-12.24,4.33-20.28 c0.7-8.04,2.45-30.77,0-43.01c-2.45-12.24-7.34-25.52-9.63-37.76c-2.28-12.23,9.61-35.65,9.63-35.67 c-0.23,0.01-0.46,0.02-0.7,0.03l-20.76,1.1C879.68,79.24,879.24,125.88,876.17,132.97z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 869.5117,
    y1: 94.1644,
    x2: 869.5117,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M864.33,201.88c-2.73-18.3,3.51-25.69,0-37.76c-3.51-12.07-6.61-16.74-3.5-28.42 c3.11-11.68,2.32-33.61,2.32-33.61s-12.2,27-10.39,38.22c1.81,11.22,4.71,36.56,2.53,48.87c-2.17,12.31,3.7,18.46,2.57,31.13 c-1.12,12.67,21.3,46.65,17.87,58.62l10.42,0.56c2.35-19.35-10.14-30.88-14.42-40.22C867.45,229.91,867.07,220.18,864.33,201.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 706.4497,
    y1: 94.1644,
    x2: 706.4497,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M687.49,114.45c10.41,11.78,14.78,21.82,11.72,37.54c-3.06,15.71,11.78,24.23,11.35,38.52 c-0.44,14.29-14.91,50.64-7.02,73.06l13.34,1.74c-6.96-9.9-3.52-22.61-2.72-39c0.81-16.39,4.03-23.91,3.49-35.52 c-0.54-11.6,6.18-21.45,10.48-33c4.3-11.55,0.27-36.81-1.84-43.8c-2.11-6.99,0-23.44,0-23.44l-5.83,0.53 c-0.03,0-0.06,0.01-0.09,0.01c-9.12,8.54-1.5,49.69-3.74,58.25c-2.23,8.56-6.7,1.86-6.07-9.3c0.63-11.16-7.7-28.66-13.85-32.75 c-6.15-4.09-2.41-13.77-2.4-13.77c-0.19,0.02-0.38,0.04-0.57,0.05l-6.25,0.6C687.49,94.16,677.08,102.66,687.49,114.45z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.5168,
    y1: 94.1644,
    x2: 353.5168,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M359.64,205.22c-0.55-11.6,6.18-21.44,10.48-33.01c3.8-10.2,1.09-31.09-1.05-40.64 c-3.32,0.37-7.08,0.82-11.22,1.34c0.41,12.98,1.94,26.37,0.76,30.84c-2.22,8.57-6.7,1.88-6.06-9.29 c0.34-5.95-1.88-13.68-4.95-20.24c-3.96,0.52-8.17,1.08-12.58,1.67c6.31,9.07,8.6,18,6.16,30.52 c-3.03,15.73,11.8,24.24,11.37,38.53c-0.03,1.09-0.17,2.35-0.35,3.69c2.5,0.34,4.99,0.68,7.47,1.02 C359.71,208.22,359.71,206.75,359.64,205.22z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.5774,
    y1: 94.1644,
    x2: 280.5774,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M284.62,167.91c-0.43-9.19,3.7-17.28,7.57-26c-7.57,1.1-15.34,2.24-23.21,3.41 c3.58,7.23,8.81,13.73,8.55,22.3c-0.2,6.65-3.44,18.09-6.05,30.66c3.2,0.39,6.52,0.8,9.92,1.22 C282.45,185.77,285.09,178.53,284.62,167.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 435.3087,
    y1: 94.1644,
    x2: 435.3087,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M449.86,189.4c-4.3-11.57-11.02-21.41-10.48-33.01c0.5-11.06-2.39-18.44-3.36-33.31 c-3.48,0.45-6.86,0.89-10.13,1.31c2.67,13.21,6.18,25.36,6.39,32.29c0.43,14.28-14.4,22.8-11.37,38.53 c1.8,9.25,1.01,16.53-2.05,23.36c3.95,0.67,7.69,1.34,11.2,1.99c1.54-4.67,2.45-9.43,2.23-13.4c-0.63-11.17,3.84-17.86,6.06-9.29 c0.98,3.71,0.1,13.55-0.47,24.2c3.49,0.71,6.66,1.4,9.41,2.06c0.79,0.19,1.66,0.39,2.56,0.59 C451.64,214.12,453.05,197.98,449.86,189.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 658.9397,
    y1: 94.1644,
    x2: 658.9397,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M678.78,241.86c2.11-6.99,6.14-32.24,1.84-43.8c-4.3-11.55-11.02-21.4-10.48-33 c0.54-11.6-2.69-19.13-3.49-35.52c-0.66-13.42-3.07-24.37-0.11-33.33c-3.98,0.4-7.93,0.8-11.87,1.2 c-4.47,22.49,7.97,54.68,8.37,67.92c0.44,14.29-14.4,22.81-11.35,38.52c3.06,15.71-1.31,25.75-11.72,37.54 c-4.45,5.04-5.08,9.46-4.36,12.89c3.38,0.48,6.73,0.95,10.07,1.41c0.07-2.6,0.89-5.38,3.52-7.13 c6.16-4.09,14.48-21.59,13.85-32.75c-0.63-11.16,3.84-17.86,6.07-9.3c1.9,7.29-3.34,38.25,0.71,52.53 c2.84,0.39,5.65,0.77,8.43,1.15C677.81,254.76,677.42,246.36,678.78,241.86z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 549.2562,
    y1: 94.1644,
    x2: 549.2562,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M568.53,233.2c2.11-6.99,6.14-32.24,1.84-43.8c-4.3-11.55-11.02-21.4-10.48-33 c0.54-11.6-2.69-19.13-3.49-35.52c-0.22-4.47-0.63-8.65-0.98-12.59c-3.83,0.45-7.62,0.89-11.37,1.34 c2.02,18.39,8.46,37.57,8.75,47.05c0.44,14.29-14.4,22.81-11.35,38.52c3.06,15.71-1.31,25.75-11.72,37.54 c-1.66,1.88-2.75,3.67-3.47,5.36c4.1,0.64,8.27,1.29,12.53,1.95c0.06-0.04,0.11-0.09,0.17-0.14c6.16-4.09,14.48-21.59,13.85-32.75 c-0.63-11.16,3.84-17.86,6.07-9.3c1.62,6.21-1.94,29.56-0.54,45.18c3.07,0.46,6.17,0.93,9.29,1.39 C567.52,240.28,567.69,235.99,568.53,233.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 966.0458,
    y1: 94.1644,
    x2: 966.0458,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M981.3,231.37c-2.55-10.2-7.09-16.22-6.38-23c0.71-6.78,5-11.07,0-22.13c-5-11.07-9.28-22.49-5.71-36.06 c3.57-13.57-2.86-31.42-7.95-41.77c-5.09-10.35-3.48-32.11-3.48-32.11h-16.1c0,0-2.53,22.69,4.2,33.91 c6.73,11.22,4.17,25.33,2.57,30.46c-1.6,5.13,0.32,16.03,6.09,25.97c5.77,9.94,13.79,26.93,11.22,40.4 c-2.57,13.47,4.17,16.91,6.41,24.32c2.24,7.42,11.23,35.34,8.66,50.72c2.95-0.02,5.87-0.05,8.74-0.09 C994.51,263.29,983.84,241.56,981.3,231.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 1041.3523,
    y1: 94.1644,
    x2: 1041.3523,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M1050.87,230.66c-1.39-10.89-5.37-17.68-3.8-24.63c1.57-6.95,6.54-10.86,2.71-22.95 c-3.83-12.09-6.87-24.46-1.5-38.09s0.89-32.92-3.12-44.28c-2.56-7.25-1.72-18.97-0.77-26.51c-5.7,0-11.41,0.03-17.16,0.07 c-1,7.87-1.55,19.03,1.77,26.43c5.61,12.46,1.22,26.77-1.07,31.9c-2.29,5.12-1.63,16.66,3.13,27.67 c4.77,11.01,11,29.62,6.69,43.26c-4.31,13.65,2.25,18.04,3.67,26.01c1.29,7.24,6.25,32.7,3.73,49.02 c3.26-0.32,6.61-0.61,10.01-0.89C1058.84,260.18,1052.1,240.31,1050.87,230.66z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 934.671,
    y1: 94.1644,
    x2: 934.671,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M950.91,257.02c-8.05-15.2-4.77-25.64-4.77-34.58c0-8.94-9.24-31.3-13.42-41.75 c-4.17-10.45-0.6-19.96,4.47-37.23c5.07-17.27-0.6-12.84-5.47-21.3c-4.87-8.46-4.17-24.65-4.17-24.65s-9.03,14.93-5.9,21.88 c3.13,6.94,7.64,19.45,5.9,28.13s-20.14,43.75-14.93,59.03c5.21,15.28,13.54,40.28,13.54,48.61c0,8.33,6.54,26.26,6.54,26.26 l8.51,0.24c1.24-7.05-8.81-27.71-8.81-35.55c0-7.84-5.23-23.78-8.89-32.67c-3.66-8.89,2.87-18.51,2.87-18.51 s6.09,15.37,8.27,21.38c2.18,6.01,2.97,19.6,4.53,25.87c1.57,6.27,11.5,27.81,9.67,39.65l8.62,0.15c0.02,0,0.03,0,0.05,0 C957.54,281.97,958.96,272.22,950.91,257.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 1137.8386,
    y1: 94.1644,
    x2: 1137.8386,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M1148.29,212.05c-3.91-11.42-2.28-11.09,1.31-21.89c3.59-10.8,5.87-12.36,1.63-25.41 c-4.24-13.05-4.89-21.53-5.22-26.79s5.22-19.87-6.2-29.98c-9.31-8.24-8.64-25.75-8.08-31.95c-5.56-0.25-11.16-0.48-16.81-0.68 c-0.23,4.69-0.78,26.8,8.22,38.98c10.1,13.67,15.45,35.35,12.48,45.16c-2.97,9.8-12.48,8.04-12.48,19.62 c0,11.58,0.43,32.08,1.4,38.61c0.82,5.49,10.68,38.92,12.11,55.8c8.02-0.27,16.08-0.54,24.12-0.81 C1161.91,252.85,1151.75,222.16,1148.29,212.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 1239.9839,
    y1: 94.1644,
    x2: 1239.9839,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M1242.38,195.38c2.97-9.8,12.48-8.04,12.48-19.62c0-11.58-0.43-32.08-1.4-38.61 c-0.75-5.03-9.1-33.55-11.59-51.26c-8.04-1.16-16.29-2.23-24.7-3.2c-0.93,19.88,9.1,50.12,12.53,60.14 c3.91,11.42,2.28,11.09-1.31,21.89c-3.59,10.8-5.87,12.36-1.63,25.41c4.24,13.05,4.89,21.53,5.22,26.79 c0.33,5.25-5.22,19.87,6.2,29.98c5.97,5.28,7.82,14.36,8.25,21.84c5.65-0.42,11.15-0.87,16.43-1.38 c-0.65-8.57-2.59-19.49-8.01-26.81C1244.75,226.88,1239.41,205.19,1242.38,195.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 778.5113,
    y1: 94.1644,
    x2: 778.5113,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M786.29,208.74c-5.63-11.64-0.75-30.05,2.63-40.94c3.38-10.89-3.01-37.19-9.77-50.33 c-5.14-9.99-8.77-24.27-10.22-30.57c-3.45,0.28-6.88,0.56-10.32,0.85c1.38,7.26,5.22,25.04,11,33.57 c7.36,10.87,12.27,29.09,6.31,45.22c-5.96,16.12-7.36,30.83-3.86,38.72c3.04,6.86,15.38,33.38,10.19,58.72 c-0.57,2.79-1.36,5.56-2.39,8.29c4.61,0.38,9.85,0.8,15.61,1.25C804.01,252.46,791.66,219.84,786.29,208.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.0352,
    y1: 94.1644,
    x2: 393.0352,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M402.74,180.8c-5.64-9.87-6.35-12.7-4.23-24.69c1.64-9.32-3.94-22.09-6.52-27.34 c-3.22,0.41-6.23,0.79-9,1.14c-0.96,5.38-3.3,19.62-2.71,26.66c1.28,15.16,22.71,26.03,12.44,57.82c3.58,0.54,7.1,1.08,10.51,1.62 C405.58,206.25,408.01,190.03,402.74,180.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.7536,
    y1: 94.1644,
    x2: 202.7536,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M210.09,168.34c0.75-4.24-0.01-9.2-1.3-13.84c-3.35,0.53-6.67,1.05-9.95,1.57h-0.12 c-2.13,0.34-4.25,0.68-6.35,1.01c-0.48,4.39-0.77,8.71-0.52,11.72c0.64,7.62,6.38,14.16,10.63,22.81 c4.12,0.12,7.91,0.24,11.25,0.37C208.65,182.95,208.05,179.89,210.09,168.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.5877,
    y1: 94.1644,
    x2: 309.5877,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M315.06,188.19c-2.12-11.99-1.41-14.81,4.23-24.69c3.8-6.64,3.6-16.91,2.31-25.78 c-3.29,0.46-6.65,0.93-10.09,1.41c3.82,24.86-13.54,34.99-14.68,48.58c-0.29,3.48,0.14,8.72,0.76,13.78 c5.13,0.64,10.4,1.31,15.75,1.99C314.87,198.45,315.89,192.88,315.06,188.19z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.3931,
    y1: 94.1644,
    x2: 243.3931,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M251.33,179.39c4.67-8.18,3.3-21.84,1.28-31.63c-3.42,0.52-6.84,1.03-10.27,1.55 c5.83,22.17-4.32,33.61-10.04,44.25c3.54,0.43,8.18,0.98,13.71,1.64C245.88,189.71,247.41,186.25,251.33,179.39z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 1084.7828,
    y1: 94.1644,
    x2: 1084.7828,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M1101.94,230.71c-3.85-10.33-3.85-30.71-2.57-43.53c1.27-12.82-4.69-25.22-6.4-33.77 c-1.71-8.55,0.43-20.95,5.13-32.49c4.69-11.5-5.06-45.96-5.13-46.19c-0.84-0.02-1.67-0.04-2.51-0.06l-10.98-0.21 c-0.91-0.01-1.82-0.03-2.73-0.04c-0.03,0.11-7.05,24.91-7.93,34c-0.88,9.11-8.23,18.09-7.06,24.18c1.18,6.1-0.84,24.33-0.13,32.56 c0.72,8.23,7.49,16.76,7.48,24.11c0,7.35-7.06,15.58-3.83,24.7c3.23,9.11,18.82,43.63,12.65,62.09l0.75-0.04 c3.05-0.18,6.13-0.35,9.26-0.51l0.26-0.01c5.94-23.45-3.82-44.24-5.94-53.13c-2.12-8.88-6.35-20.31-5.99-35.96 s-4.16-16.5-5.85-31.09c-1.68-14.59,11.84-39.14,11.84-39.14s-2.61,28.38,1.6,42.28c4.2,13.89,2.52,27.5,2.52,36.45 c0,8.95,5.88,30.38,8.4,40.47c2.52,10.08,8.35,17.98,3.73,39.62l1.66-0.07c2.21-0.1,4.42-0.2,6.64-0.29l0.26-0.01 C1110.08,261.63,1105.79,241.04,1101.94,230.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 1189.4995,
    y1: 94.1644,
    x2: 1189.4995,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M1212.52,217.88c-1.18-6.1,0.84-24.33,0.13-32.56c-0.72-8.23-7.49-16.76-7.48-24.11 c0-7.35,7.06-15.58,3.83-24.7c-2.91-8.21-15.8-36.99-13.82-56.12c-3.33-0.31-6.66-0.62-10.04-0.91 c-3.75,21.58,4.91,40.32,6.89,48.63c2.12,8.88,6.35,20.31,5.99,35.96c-0.35,15.65,4.16,16.5,5.85,31.09 c1.68,14.59-11.84,39.14-11.84,39.14s2.61-28.38-1.6-42.28c-4.2-13.89-2.52-27.5-2.52-36.45c0-8.95-5.88-30.38-8.4-40.47 c-2.39-9.57-7.75-17.19-4.34-36.44c-2.77-0.21-5.58-0.41-8.38-0.6c-2.11,13.02,1.92,31.96,5.56,41.72 c3.85,10.33,3.85,30.71,2.57,43.53c-1.27,12.82,4.69,25.22,6.4,33.77c1.71,8.55-0.43,20.95-5.13,32.49 c-3.76,9.23,1.77,33.22,4.14,42.47c6.22-0.22,12.4-0.46,18.51-0.71c2.08-7.67,5.99-22.64,6.63-29.28 C1206.34,232.95,1213.69,223.98,1212.52,217.88z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_76_",
    gradientUnits: "userSpaceOnUse",
    x1: 750.4595,
    y1: 94.1644,
    x2: 750.4595,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M757.92,200.71c8.06-29.95-3.43-48.98-3.87-52.8c-1.77-15.53,1.95-19.01-2.89-35.18 c-2.8-9.35-3.56-18.21-3.72-24.04c-1.96,0.17-3.91,0.33-5.86,0.5c-0.88,7.88-2.92,29.67,0.34,37.98c4.01,10.22,0.46,17.17,0,22.63 c-0.46,5.46,12.45,17.86,8.48,40.19c-3.97,22.34-11.91,19.85-7.44,40.7c4.15,19.35,8.64,26.92,3.94,38.34 c4.03,0.48,7.7,0.89,10.93,1.24C765.82,246.02,750.72,227.45,757.92,200.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_77_",
    gradientUnits: "userSpaceOnUse",
    x1: 1004.1936,
    y1: 94.1644,
    x2: 1004.1936,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M989.47,114.95c10.1,13.68,15.44,35.35,12.47,45.16c-2.97,9.81-12.47,8.05-12.47,19.62 c0,11.57,0.43,32.06,1.39,38.61c0.98,6.52,14.8,52.72,11.92,63.34l8.28-0.43c0.81-23.87-7.94-55.29-11.89-71.05 c-4.3-17.17,3.98-26.9,3.98-26.9s0.84,21.1,5.6,32.64c4.36,10.56,10.01,44.96,9.96,64.9l7.39-0.4 c4.93-18.67-7.56-56.36-11.46-67.79c-3.92-11.4-2.31-11.08,1.3-21.87c3.58-10.79,5.86-12.38,1.62-25.42 c-4.24-13.04-4.88-21.53-5.22-26.78c-0.32-5.25,5.22-19.85-6.18-29.98c-10.8-9.55-8.2-31.55-7.88-33.93 c-5.64,0.11-11.29,0.23-16.97,0.38C981.3,75.13,979.39,101.32,989.47,114.95z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 1286.5994,
    y1: 94.1644,
    x2: 1286.5994,
    y2: 229.1075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st80",
    d: "M1298.42,190.78c3.59-10.8,5.87-12.36,1.63-25.41c-4.24-13.05-4.89-21.53-5.22-26.79 c-0.33-5.25,5.22-19.87-6.2-29.98c-4.5-3.99-6.65-10.14-7.63-16.13c-5.3-0.96-10.5-1.89-15.48-2.78 c-0.48-0.09-0.99-0.16-1.47-0.25c0.75,8.35,2.77,18.55,7.91,25.51c10.1,13.67,15.45,35.35,12.48,45.16 c-2.97,9.8-12.48,8.04-12.48,19.62c0,11.58,0.43,32.08,1.4,38.61c0.69,4.6,7.73,28.85,10.83,46.51c1.93-0.27,3.82-0.56,5.66-0.85 c0.93-0.15,1.9-0.3,2.86-0.46c-2.21-20.01-8.04-41.27-11.06-53.33c-4.29-17.16,3.99-26.88,3.99-26.88s0.83,21.08,5.6,32.61 c3.19,7.73,7.06,28.2,8.89,46.44c2.91-0.45,5.9-0.91,9-1.38c-2.04-18.5-9.22-40.15-12.02-48.33 C1293.2,201.25,1294.83,201.58,1298.42,190.78z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 1475.4681,
    y1: 140.3155,
    x2: 1468.7455,
    y2: 237.1214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M1507.42,194.91c-0.03,0.03-0.06,0.03-0.06,0.03s82.22-3.75,112.06-3.43c0.69,1.62-0.09,3.46-4.04,5.45 c-0.23,0.12-0.58,0.26-1.01,0.46c-11.69,4.62-86.17,23.89-150.84,38.04c-0.03,0-0.06,0.03-0.12,0.03c-0.84,0.2-1.64,0.35-2.48,0.52 c-2.65,0.58-5.28,1.15-7.88,1.7c-0.98,0.23-1.96,0.43-2.91,0.63c-0.06,0-0.12,0.03-0.17,0.03c-4.21,0.92-8.4,1.76-12.47,2.6 c-1.36,0.26-2.71,0.55-4.04,0.81c-1.21,0.23-2.4,0.49-3.61,0.72c-2.83,0.58-5.63,1.13-8.34,1.64l-2.77,0.52 c-0.52,0.09-1.01,0.17-1.53,0.29c-0.23,0.03-0.35,0.06-0.38,0.06c-3.58,0.66-7.04,1.3-10.36,1.88c-0.06,0-0.14,0.03-0.2,0.03 c-6.93,0.98-13.85,1.99-20.69,2.94c-1.73,0.26-3.46,0.52-5.19,0.75c-39.59-0.98-46.2-20.89-48.89-26.61 c-2.71-5.74-1.7-27.93-3.72-33.68c-2.02-5.71-4.36-10.76-1.67-17.49c0.87-2.19,5.43-4.82,11.17-7.36c0.17-0.2,0.35-0.4,0.46-0.61 c0.61-0.78,1.1-1.5,1.47-2.22c5.28-9.52-6.78-14.14-3.95-19.54c3.12-5.94,7.59-2.37,6.9-12.61c-0.26-3.95,4.53-8.63,10.56-12.9 h0.03c0.61-0.43,1.21-0.87,1.85-1.27c1.59-1.1,3.26-2.14,4.91-3.12c0.66-0.4,1.36-0.78,2.02-1.18c2.14-1.21,4.18-2.34,6.03-3.29 c7.33,1.44,14.75,2.91,22.28,4.42c2.51,0.52,5.05,1.01,7.59,1.53c0.55,0.12,1.07,0.2,1.62,0.32c1.85,0.38,3.72,0.75,5.57,1.13 c1.82,0.38,3.66,0.75,5.51,1.13c0.84,0.17,1.67,0.35,2.51,0.52c4.47,0.92,8.97,1.85,13.48,2.8c4.85,1.04,9.73,2.05,14.63,3.09 c4.88,1.07,9.78,2.11,14.72,3.17c0.23,0.03,0.46,0.09,0.69,0.14c4.36,0.95,8.74,1.9,13.13,2.89c7.47,1.64,14.98,3.35,22.48,5.05 c5.4,1.24,10.82,2.51,16.22,3.78c1.07,0.26,2.14,0.49,3.2,0.75c4.65,1.1,9.29,2.19,13.94,3.32c0.75,0.17,1.47,0.35,2.19,0.55 c0.12,0.03,0.23,0.06,0.38,0.09c0.06,0,0.12,0.03,0.2,0.03c0.14,0.03,0.29,0.06,0.43,0.12c0.03,0,0.09,0.03,0.12,0.03 c0.09,0.03,0.12,0.03,0.12,0.03c0.17,0.03,0.35,0.09,0.52,0.12c1.59,0.38,3.15,0.72,4.73,1.13c1.76,0.43,3.49,0.87,5.22,1.3 c3.87,0.95,7.76,1.9,11.63,2.89c1.7,0.43,3.43,0.84,5.14,1.3c1.1,0.26,2.16,0.52,3.26,0.81c1.07,0.26,2.14,0.55,3.2,0.81 c1.62,0.4,3.2,0.81,4.79,1.24c0.58,0.14,1.15,0.29,1.73,0.43c3.61,0.92,7.16,1.85,10.74,2.8h0.03c0.32,0.09,0.63,0.17,0.95,0.26 c3.58,0.92,7.1,1.88,10.65,2.83c10.07,2.71,20.09,5.48,29.93,8.31c0,0,3.12,2.83-8.95,6.06c-0.03,0-0.03,0-0.03,0 c-0.55,0.17-1.15,0.32-1.76,0.46c-0.87,0.2-2.02,0.46-3.41,0.78c-0.66,0.14-1.36,0.29-2.14,0.46c-1.27,0.29-2.68,0.58-4.18,0.89 c-0.98,0.2-1.99,0.4-3.06,0.63c-1.18,0.26-2.42,0.49-3.69,0.75c-1.62,0.35-3.32,0.69-5.08,1.07c-0.66,0.12-1.3,0.23-1.93,0.38 c-1.3,0.26-2.6,0.52-3.95,0.81c-0.69,0.12-1.36,0.26-2.05,0.4c-1.36,0.26-2.77,0.55-4.18,0.84c-1.41,0.29-2.86,0.58-4.3,0.87 l-2.16,0.43c-2.51,0.49-5.05,0.98-7.62,1.5c-1.13,0.23-2.28,0.46-3.43,0.69c-7.42,1.44-14.83,2.91-21.64,4.24 c-0.98,0.2-1.96,0.38-2.94,0.58c-4.3,0.84-8.31,1.62-11.86,2.31c-0.55,0.09-1.07,0.2-1.59,0.32c-1.56,0.29-3.03,0.58-4.36,0.84 c-0.43,0.09-0.89,0.17-1.3,0.26c-0.84,0.14-1.64,0.29-2.37,0.43c-0.61,0.14-1.15,0.23-1.64,0.35 C1509.15,194.59,1507.74,194.85,1507.42,194.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.9607,
    y1: 158.1383,
    x2: 181.2878,
    y2: 260.7408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "180.5,191.08 190.88,200.44 204.62,191.68  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.5889,
    y1: 164.4154,
    x2: 219.916,
    y2: 267.0179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "213.8,191.99 229.88,204.95 249.81,195.67  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.2673,
    y1: 172.0006,
    x2: 266.5944,
    y2: 274.6031
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st84",
    points: "261.27,197.04 277.05,212.76 296.42,201.36  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.3553,
    y1: 179.9774,
    x2: 315.6824,
    y2: 282.5799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st85",
    points: "307.21,202.72 326.03,216.44 349.22,208.21  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.0832,
    y1: 189.1957,
    x2: 372.4102,
    y2: 291.7982
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "364.32,210.28 384.9,226.16 406,216.44  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_85_",
    gradientUnits: "userSpaceOnUse",
    x1: 443.2289,
    y1: 197.9944,
    x2: 426.556,
    y2: 300.5969
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "419.32,218.63 438.77,235.63 459.13,226.65  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_86_",
    gradientUnits: "userSpaceOnUse",
    x1: 491.5754,
    y1: 205.8507,
    x2: 474.9025,
    y2: 308.4532
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "466.82,228.12 484.1,243.5 507.94,235.18  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.079,
    y1: 213.7325,
    x2: 523.4061,
    y2: 316.335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "518.96,236.95 532.46,253.03 552.8,242.2  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 1207.7657,
    y1: 142.1659,
    x2: 1314.0125,
    y2: 193.6546
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M1292.77,209.79c-0.8,0.35-1.64,0.55-2.48,0.61c-5.98,0.39-9.16-3.34-12.83-8.13 c-4.66-6.17-10.06-14.15-23.05-17.27c-16.67-3.99-53.76-24.86-73.07-36.15c-3.63-2.12-2.2-7.68,2.01-7.76 c25.48-0.49,79.35,0.35,113.05,14.32c4.57,1.9,8.78,4.02,12.47,6.43C1315.95,166.45,1305.47,204.52,1292.77,209.79z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 1585.1134,
    y1: 165.5559,
    x2: 1526.9181,
    y2: 212.5001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M1610.33,174.33c-13.94,3.38-100.2,20.09-102.91,20.58c16.31-12.18,56.5-31.25,72.12-38.5 c0.32,0.09,0.63,0.17,0.95,0.26c3.58,0.92,7.1,1.88,10.65,2.83c10.07,2.71,20.09,5.48,29.93,8.31c0,0,3.12,2.83-8.95,6.06 c-0.03,0-0.03,0-0.03,0C1611.54,174.04,1610.93,174.19,1610.33,174.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 1541.5858,
    y1: 250.8319,
    x2: 1537.6416,
    y2: 223.8799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D4B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M1615.38,196.96c-0.23,0.12-0.58,0.26-1.01,0.46c-11.69,4.62-86.17,23.89-150.84,38.04 c-0.03,0-0.06,0.03-0.12,0.03c-0.84,0.2-1.64,0.35-2.48,0.52c-2.65,0.58-5.28,1.15-7.88,1.7c16.13-13.04,33.76-26.64,36.68-28.97 c10.19-8.25,17.63-13.79,17.63-13.79s82.22-3.75,112.06-3.43C1620.11,193.12,1619.33,194.97,1615.38,196.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 784.6983,
    y1: 95.3921,
    x2: 779.4529,
    y2: 224.4296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M1367.54,108.74c-4.39,2.28-9.98,5.43-14.8,8.86c-27.88-5.4-57.2-10.85-89.23-16.54 c-56.94-10.19-130.27-15.32-217.91-15.32c-76.76,0-165.79,3.95-264.66,11.75c-0.63,0.09-1.27,0.14-1.9,0.17 c-148.85,11.83-285.96,29.64-359.63,39.22L313.38,151.3c-33.36-1.27-69.98-0.29-114.54,4.76c62.74-9.96,139.21-21.07,171.22-24.62 c43.86-4.88,215.63-30.01,408.2-45.31c0.55-0.03,1.1-0.09,1.64-0.14c170.61-13.48,357.32-19.22,485.63,3.69 C1294.71,94.89,1329.57,101.26,1367.54,108.74z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M619.77,252.05c-1.21-0.17-2.42-0.35-3.64-0.52c-14.46-2.08-29-4.18-43.23-6.29 c-1.76-0.29-3.52-0.55-5.28-0.81c-3.12-0.46-6.23-0.92-9.29-1.39c-1.85-0.29-3.69-0.58-5.54-0.84l-3.75-0.58l-6.12-0.95l-4.13-0.63 l-9.67-1.5c-0.98-0.14-1.93-0.29-2.89-0.43c-0.35-0.06-0.69-0.12-1.04-0.17l-6.23-0.98c-2.08-0.35-4.16-0.66-6.2-0.98 c-0.52-0.09-1.07-0.17-1.59-0.26c-1.1-0.17-2.16-0.38-3.23-0.55l-0.17-0.03c-1.44-0.23-2.86-0.46-4.24-0.66 c-2.57-0.43-5.11-0.84-7.56-1.27c-0.72-0.12-1.41-0.23-2.11-0.35c-2.48-0.4-4.88-0.81-7.21-1.21c-7.3-1.24-13.97-2.42-19.83-3.52 c-2.74-0.52-5.31-1.01-7.71-1.47l-5.57-1.13c-1.33-0.29-2.54-0.55-3.69-0.81c-0.92-0.2-1.76-0.4-2.57-0.61 c-2.74-0.66-5.92-1.36-9.41-2.05c-2.45-0.52-5.05-1.01-7.82-1.53c-3.2-0.58-6.55-1.18-10.13-1.79l-0.61-0.12 c-0.14-0.03-0.32-0.06-0.46-0.09c-4.1-0.69-8.4-1.39-12.87-2.11c-0.92-0.14-1.82-0.29-2.77-0.43c-3.41-0.52-6.93-1.07-10.5-1.62 c-10.48-1.59-21.64-3.17-33.04-4.76c-2.48-0.32-4.99-0.66-7.47-1.01c-0.98-0.14-1.96-0.26-2.97-0.4l-1.36-0.17 c-11.6-1.59-23.26-3.09-34.54-4.53l-5.37-0.69l-0.75-0.09c-1.18-0.14-2.37-0.32-3.55-0.46c-2.05-0.26-4.07-0.52-6.06-0.78 c-5.6-0.69-11.02-1.36-16.22-1.99c-3.41-0.43-6.72-0.84-9.93-1.24c-3.55-0.4-6.95-0.84-10.19-1.21c-4.1-0.49-7.94-0.95-11.46-1.39 c-1.3-0.14-2.57-0.32-3.78-0.46c-2.97-0.35-5.66-0.66-8.08-0.98c-0.61-0.06-1.21-0.12-1.79-0.2c-1.41-0.17-2.68-0.32-3.84-0.46 c-2.91-0.35-5.08-0.61-6.38-0.78c-2.48-0.32-6.69-0.58-12.15-0.78c0,0-0.03,0-0.06,0v-0.03c-0.72,0-1.5-0.03-2.28-0.09 c-0.98,0-1.99-0.06-3.03-0.09c-1.53-0.06-3.12-0.12-4.76-0.14c-0.4-0.03-0.78-0.03-1.18-0.06c-6.2-0.17-13.13-0.32-20.43-0.49 l-1.56-0.03c-6.2-0.14-12.64-0.29-19.08-0.46v0.26c-14.95,3.43-29.35,9.81-45.42,31.37c-1.44,0.2-2.86,0.43-4.27,0.69 c-21.47,3.72-28.19-14.57-8.57-28.86c6.44-4.73,15.73-9,28.28-11.92c10.45-2.42,20.4-4.53,29.98-6.32 c59.88-11.23,105.85-10.79,172.51-6.72c96.76,5.89,187.58,22.6,263.39,45.94C606.52,217.88,615.61,235.05,619.77,252.05z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 1370.7928,
    y1: 123.5433,
    x2: 1398.2476,
    y2: 272.33
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M1450.14,238.34c-0.06,0-0.12,0.03-0.17,0.03c-4.21,0.92-8.4,1.76-12.47,2.6c-1.36,0.26-2.71,0.55-4.04,0.81 c-1.21,0.23-2.4,0.49-3.61,0.72c-2.83,0.58-5.63,1.13-8.34,1.64l-2.77,0.52c-0.52,0.09-1.01,0.17-1.53,0.29 c-0.23,0.03-0.35,0.06-0.38,0.06c-3.58,0.66-7.04,1.3-10.36,1.88c-0.06,0-0.14,0.03-0.2,0.03c-6.93,0.98-13.85,1.99-20.69,2.94 c-1.73,0.26-3.46,0.52-5.19,0.75c-39.59-0.98-46.2-20.89-48.89-26.61c-2.71-5.74-1.7-27.93-3.72-33.68 c-2.02-5.71-4.36-10.76-1.67-17.49c0.87-2.19,5.43-4.82,11.17-7.36c0.17-0.2,0.35-0.4,0.46-0.61c0.61-0.78,1.1-1.5,1.47-2.22 c8.97-3.46,35.09-4.13,20.86,21.61c-11.25,20.37,39.23,3.9,32.73,24.5C1381.8,243.6,1426.24,238.25,1450.14,238.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 1477.7672,
    y1: 235.4542,
    x2: 1477.7672,
    y2: 235.4542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D4B56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M1477.77,235.45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_94_",
    gradientUnits: "userSpaceOnUse",
    x1: 1509.832,
    y1: 151.0628,
    x2: 1498.2509,
    y2: 193.0983
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20243B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#72818B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9EB0B9"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M1567.04,153.18c-15.76,8.6-36.04,14.52-54.92,18.53c-29.67,6.32-55.9,7.96-55.9,7.96s-1.24-4.16-2.4-9.67 c-2.16-10.48-3.92-25.89,4.13-26.84c13.48-1.62,31.74-3.32,50.01-4.47c1.07,0.26,2.14,0.49,3.2,0.75c4.65,1.1,9.29,2.19,13.94,3.32 c0.87,0.17,1.7,0.38,2.57,0.63c0.06,0,0.12,0.03,0.2,0.03c0.14,0.03,0.29,0.06,0.43,0.12c0.03,0,0.09,0.03,0.12,0.03 c0.09,0.03,0.12,0.03,0.12,0.03c0.17,0.03,0.35,0.09,0.52,0.12c1.59,0.38,3.15,0.72,4.73,1.13c1.76,0.43,3.49,0.87,5.22,1.3 c3.87,0.95,7.76,1.9,11.63,2.89c1.7,0.43,3.43,0.84,5.14,1.3c1.1,0.26,2.16,0.52,3.26,0.81c1.07,0.26,2.14,0.55,3.2,0.81 C1563.87,152.34,1565.45,152.75,1567.04,153.18z"
  })), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1459.14,
    cy: 161.73,
    r: 18.62
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_95_",
    gradientUnits: "userSpaceOnUse",
    x1: 1471.5598,
    y1: 199.8302,
    x2: 1458.2775,
    y2: 159.0777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5FB6D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    style: {
      stopColor: "#B3DCEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st97",
    cx: 1459.14,
    cy: 161.73,
    r: 15.87
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1459.14,
    cy: 161.73,
    r: 10.31
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st98",
    cx: 1461.89,
    cy: 155.08,
    r: 1.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishResult12);
export default __webpack_public_path__ + "static/media/fish-result-12.34f262e75a342121bdc4a2a5176d7d48.svg";
export { ForwardRef as ReactComponent };